"use client";
import React from 'react';
import OurTeamClient from './OurTeamClient';
import { ourTeamData } from '@/data/our-team.data';
import SectionHeader from '@/components/shared/headers/SectionHeader';
import { useDict } from "@/components/providers/LocaleProvider";

export default function OurTeam() {
  const t = useDict();
  return (
    <section className="space-y-8">
      <SectionHeader title={t.home.team.title} description={t.home.team.description} />

      <section>
        <OurTeamClient teamMembers={ourTeamData} />
      </section>
    </section>
  );
}
